module.exports = __webpack_public_path__ + "img/pethouse06.98986a89.jpg";